// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"f8962543","592":"dd034f8a","712":"641d7c66","716":"81405ad2","916":"d6575fe1"}[chunkId] + ".chunk.js";
};